import { NumberEnum } from '../../../../../util/enums/NumberEnum';

export const getChartWidth = (isMobile: boolean) => (isMobile ? 580 : 1080);

export const getResultsCount = (isMobile: boolean) => (isMobile ? 5 : 7);

export const getBarWidth = (isMobile: boolean, extraBar?: boolean) => {
  if (extraBar) {
    return isMobile ? 22 : 30;
  }
  return isMobile ? 30 : 40;
};

export const getBarLocation = (isMobile: boolean, index: number) => index + (isMobile ? 2 : 4);

export const getChartOffset = (isMobile: boolean, extraBar?: boolean) => {
  if (extraBar) {
    return isMobile ? 14 : 26;
  }
  return isMobile ? 26 : 40;
};

export const getChartDomainLength = (isMobile: boolean, dataLength: number, extraBar?: boolean) => {
  if (extraBar) {
    return dataLength + (isMobile ? 0 : 4);
  }
  return dataLength + (isMobile ? 0 : 3.5);
};

export const formatNumber = (num: number, index?: number) => {
  if (index && index % 2 !== 0) return '';
  const operator = num < 0 ? '-' : '';
  let formattedNumber = '';
  const absNum = Math.abs(num);

  if (absNum >= NumberEnum.Billion) {
    formattedNumber = `${(absNum / NumberEnum.Billion).toFixed(1)}b`;
  } else if (absNum >= NumberEnum.Million) {
    formattedNumber = `${(absNum / NumberEnum.Million).toFixed(1)}m`;
  } else {
    formattedNumber = `${(absNum / NumberEnum.Thausand).toFixed(0)}k`;
  }

  formattedNumber = formattedNumber.replace('.0', '');

  return `${operator}${formattedNumber}`;
};
